/* eslint-disable no-var */
import {AppConfig} from "@pershing/shell-comms";
import {environment} from "./environments/environment";
import {FullStory, init as initFullStory} from "@fullstory/browser";

declare global {
  interface Window {
    appConfig: AppConfig;
    ASSETS_BASE_URL: string;
    QSI?: {
      API?: {
        load: () => Promise<void>;
        run: () => void;
      };
    };
  }
}

// All the code here is written keeping in mind to ensure compatibility with older devices
// although const, optional chaining (eg window?.appConfig?.firmId) and string formation using `${}` are easier to write,
// many older browsers don't support it.
// So, we are using var and traditional string concatenation
// Although it is bad to use var when the value is constant, it is used here to ensure compatibility with older browsers
export function initializeFullStory() {
  var orgId = environment.fullstoryOrgId;
  var isFullstoryNeededForCurrentEnv = environment.fullStoryEnvironments.indexOf(window.appConfig && window.appConfig.woveRegion) !== -1;
  if (!orgId || !isFullstoryNeededForCurrentEnv) {
    return;
  }
  initFullStory({ orgId, debug: false });
  FullStory("observe", {
    type: "start",
    callback: () => {
      initializeQualtrics();
    }
  });
}

function initializeQualtrics() {
  // Need to wait until FullStory is initialized before initializing Qualtrics,
  // otherwise the fullstory session id isn't being captured in the user feedback
  // https://api.qualtrics.com/7023b0cd7acdd-website-feedback-java-script-api
  window.addEventListener("qsi_js_loaded", () => {
    if (typeof window.QSI?.API?.load === "function") {
      void window.QSI.API.load().then(window.QSI.API.run);
    }
  }, false);
}

// All the code here is written keeping in mind to ensure compatibility with older devices
// although const, optional chaining (eg window?.appConfig?.firmId) and string formation using `${}` are easier to write,
// many older browsers don't support it.
// So, we are using var and traditional string concatenation
// Although it is bad to use var when the value is constant, it is used here to ensure compatibility with older browsers
export function showIncompatibleBrowserErrorPage() {
  var assetsUrl = window.ASSETS_BASE_URL || "";
  // Show error page
  void fetch(`${assetsUrl}/assets/incompatible-browser-error.html`)
    .then(response => response.text())
    .then(html => {
      document.body.innerHTML = html;
      
      // Scripts won't be added by default in the HTML
      // this is because <script> can contain malicious scripts which might compromise security
      // but in this case we trust the content of the HTML since we own the code
      // so we need to manually add them.
      var tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      var scriptsInHtml = tempDiv.querySelectorAll("script");
      scriptsInHtml.forEach((script) => {
        var newScript = document.createElement("script");
        if (script.src) {
          newScript.src = script.src;
        } else {
          newScript.textContent = script.textContent;
        }
        document.body.appendChild(newScript);
      });
    });
}